document.addEventListener('DOMContentLoaded', function () {
  // Function to move the Loox widget into the target container
  function moveLooxWidget() {
    const looxWidget = document.querySelector('.loox-widget');
    const targetContainer = document.querySelector('.looxreviewshere');

    if (looxWidget && targetContainer && !targetContainer.contains(looxWidget)) {
      targetContainer.innerHTML = ''; // Optional: clear any placeholder
      targetContainer.appendChild(looxWidget);
      console.log('✅ Loox widget moved into .looxreviewshere');
      return true;
    }
    return false;
  }

  // Try immediately on DOM load
  if (!moveLooxWidget()) {
    // If the widget hasn't been injected yet, watch for it
    const observer = new MutationObserver(() => {
      if (moveLooxWidget()) {
        observer.disconnect();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }
});









document.addEventListener('DOMContentLoaded', function () {
  // Function to move the Loox widget into the target container
  function moveLooxWidget() {
    const looxWidget = document.querySelector('.loox-trust-badge-container');
    const targetContainer = document.querySelector('.looxreviewshere2');

    if (looxWidget && targetContainer && !targetContainer.contains(looxWidget)) {
      targetContainer.innerHTML = ''; // Optional: clear any placeholder
      targetContainer.appendChild(looxWidget);
      console.log('✅ Loox widget moved into .looxreviewshere2');
      return true;
    }
    return false;
  }

  // Delay execution slightly to allow Loox styling to load
  setTimeout(function () {
    if (!moveLooxWidget()) {
      // If the widget hasn't been injected yet, watch for it
      const observer = new MutationObserver(() => {
        if (moveLooxWidget()) {
          observer.disconnect();
        }
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    }
  }, 50); // 50ms delay
});









function getInstafeedData() {
  const feedItems = document.querySelectorAll('.instafeed-new-layout-item');
  const results = [];

  feedItems.forEach(item => {
    const linkEl = item.querySelector('a');
    const imgEl = item.querySelector('.instafeed-lazy-image');

    if (!linkEl || !imgEl) return;

    // Prefer data-instafeed-src, then fallback to data-src or src
    const src =
      imgEl.getAttribute('data-instafeed-src') ||
      imgEl.getAttribute('data-src') ||
      imgEl.getAttribute('src');

    // Only push valid, non-placeholder sources
    if (src && !src.includes('placeholder')) {
      results.push({
        href: linkEl.href,
        src,
        alt: imgEl.getAttribute('alt') || ''
      });
    }
  });

  return results;
}

function waitForInstafeed(callback) {
  const interval = setInterval(() => {
    const items = document.querySelectorAll('.instafeed-new-layout-item');
    if (items.length > 0) {
      clearInterval(interval);
      callback();
    }
  }, 500);
}


// Helper: wait for all images inside container to fully load
function imagesLoaded(container, onComplete) {
  const imgs = container.querySelectorAll('img');
  let loaded = 0;
  const total = imgs.length;

  if (total === 0) return onComplete();

  imgs.forEach(img => {
    if (img.complete && img.naturalWidth > 0) {
      loaded++;
    } else {
      img.addEventListener('load', () => {
        loaded++;
        if (loaded === total) onComplete();
      });
      img.addEventListener('error', () => {
        loaded++;
        if (loaded === total) onComplete();
      });
    }
  });

  if (loaded === total) onComplete();
}

waitForInstafeed(() => {
  const section = document.querySelector('#shopify-section-CHIMAC-INSTA');
  if (!section) return;

  const tickerTrack = section.querySelector('.ticker-track');
  if (!tickerTrack) return;

  // Wait a short moment for Instafeed to swap placeholder images
  setTimeout(() => {
    const instaArray = getInstafeedData();
    if (!instaArray.length) {
      console.warn('⚠️ No valid Instafeed images found yet.');
      return;
    }

    // Clear existing content
    tickerTrack.innerHTML = '';

    // Build and insert Instagram items
    instaArray.forEach(item => {
      const wrapper = document.createElement('div');
      wrapper.className = 'image-insta-cont';
      wrapper.innerHTML = `
        <a href="${item.href}" target="_blank" rel="noopener" class="insta-link" aria-label="link to instagram post">
          <img src="${item.src}" alt="${item.alt || 'Instagram post'}" class="insta-img" height="auto" width="auto" />
        </a>`;
      tickerTrack.appendChild(wrapper);
    });

    console.log(`✅ Injected ${instaArray.length} Instagram posts into ticker`);

    const tickerOuter = section.querySelector('.ticker-outer');
    if (!tickerOuter) return;

    // ✅ Wait for all images to fully load before initializing ticker
    imagesLoaded(tickerOuter, () => {
      if (tickerOuter.refreshTicker) {
        tickerOuter.refreshTicker();
        console.log('🎬 Ticker initialized after all images fully loaded.');
      }
    });

  }, 150); // small delay to let Instafeed replace placeholders
});



















document.addEventListener("DOMContentLoaded", () => {
  const hamburger = document.querySelector(".hamburger-mobile-cont");
  const sideNav = document.getElementById("mobile-side-nav");
  const targetNavs = [
    document.getElementById("reg-nav"),
    document.getElementById("reg-nav-ab"),
    document.getElementById("main-nav")
  ];
  const focusableSelectors = 'a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])';
  let lastFocusedElement = null;

  function openNav() {
    sideNav.classList.add("active");
    hamburger.classList.add("active");
    sideNav.setAttribute("aria-hidden", "false");
    hamburger.setAttribute("aria-expanded", "true");
    hamburger.setAttribute("aria-label", "Close menu");
    lastFocusedElement = document.activeElement;

    // Add highlight class to target navs
    targetNavs.forEach(el => el && el.classList.add("nav-overlay-active"));

    // Focus first link inside menu
    const firstLink = sideNav.querySelector(focusableSelectors);
    if (firstLink) firstLink.focus();

    trapFocus();
  }

  function closeNav() {
    sideNav.classList.remove("active");
    hamburger.classList.remove("active");
    sideNav.setAttribute("aria-hidden", "true");
    hamburger.setAttribute("aria-expanded", "false");
    hamburger.setAttribute("aria-label", "Open menu");

    // Remove highlight class from target navs
    targetNavs.forEach(el => el && el.classList.remove("nav-overlay-active"));

    // Return focus
    if (lastFocusedElement) lastFocusedElement.focus();
  }

  function trapFocus() {
    const focusableEls = sideNav.querySelectorAll(focusableSelectors);
    const firstEl = focusableEls[0];
    const lastEl = focusableEls[focusableEls.length - 1];

    function handleTrap(e) {
      if (e.key !== "Tab") return;

      if (e.shiftKey) { // Shift + Tab
        if (document.activeElement === firstEl) {
          e.preventDefault();
          lastEl.focus();
        }
      } else { // Tab
        if (document.activeElement === lastEl) {
          e.preventDefault();
          firstEl.focus();
        }
      }
    }

    sideNav.addEventListener("keydown", handleTrap);

    // Remove trap on close
    sideNav.addEventListener("transitionend", () => {
      if (!sideNav.classList.contains("active")) {
        sideNav.removeEventListener("keydown", handleTrap);
      }
    });
  }

  // Toggle
  hamburger.addEventListener("click", () => {
    const isOpen = sideNav.classList.contains("active");
    isOpen ? closeNav() : openNav();
  });

  // ESC key closes
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && sideNav.classList.contains("active")) {
      closeNav();
    }
  });
});











  document.addEventListener("DOMContentLoaded", function () {
    const productCards = document.querySelectorAll(".product-card-outer");

    productCards.forEach((card) => {
      const video = card.querySelector(".hover-vid");

      if (video) {
        card.addEventListener("mouseenter", () => {
          video.play();
        });

        card.addEventListener("mouseleave", () => {
          video.pause();
          video.currentTime = 0; // optional: reset on hover out
        });
      }
    });
  });






const slides = document.querySelectorAll('.swiper-slide');
const useLoop = slides.length > 5;

// Product swiper
const swiperProd = new Swiper(".swiper", {
  navigation: {
    nextEl: ".prodnext",
    prevEl: ".prodprev",
  },
  centeredSlides: false,
  loop: useLoop,
  slidesPerView: 2,   // base config
  spaceBetween: 0,    // base config
  keyboard: {
    enabled: true,
    onlyInViewport: true
  },
  enabled: false, // disabled by default
  breakpoints: {
    640: {
      slidesPerView: 'auto',
    },
    768: {
      enabled: true,
      slidesPerView: 3,
      spaceBetween: 20,
    },

        1024: {
      enabled: true,
      slidesPerView: 3,
      spaceBetween: 20,
    },
    1424: {
      enabled: true,
      slidesPerView: 5,
      spaceBetween: 20,
    },
  },
});

// Review swiper
const swiperReview = new Swiper(".swiperreview", {
  navigation: {
    nextEl: ".reviewnext",
    prevEl: ".reviewprev",
  },
  centeredSlides: false,
  loop: useLoop,
  slidesPerView: 2,   // base config
  spaceBetween: 0,    // base config
  enabled: false, // disabled by default
  keyboard: {
    enabled: true,
    onlyInViewport: true
  },
  breakpoints: {
    640: {
      slidesPerView: 'auto',
    },
    768: {
      enabled: true,
      slidesPerView: 3,
      spaceBetween: 20,
    },

        1024: {
      enabled: true,
      slidesPerView: 3,
      spaceBetween: 20,
    },
    1424: {
      enabled: true,
      slidesPerView: 5,
      spaceBetween: 20,
    },
  },
});

// Thumbnail product swiper (⚠️ must come before main)
const swiperThumbProd = new Swiper(".swiper-thumb-prod", {
  loop: true,
  enabled: true,
    slidesPerView: 4,   // 👈 base config (applies below 640px)
  spaceBetween: 5,    // 👈 base spacing
  keyboard: {
    enabled: true,
    onlyInViewport: true
  },
  breakpoints: {
    640: {
      slidesPerView: 4,
      spaceBetween: 7,
    },
    768: {
      slidesPerView: 4,
      spaceBetween: 10,
    },
    1024: {
      slidesPerView: 4,
      spaceBetween: 10,
    },
  },
});

// Main product swiper, linked to thumbs
const swiperMainProd = new Swiper(".swiper-main-prod", {
  navigation: {
    nextEl: ".prodnext",
    prevEl: ".prodprev",
  },
  enabled: true,
  effect: "fade",
  centeredSlides: true,
  loop: true,
  spaceBetween: 30,
  keyboard: {
    enabled: true,
    onlyInViewport: true
  },
  thumbs: {
    swiper: swiperThumbProd, // ✅ linked properly
  },
  breakpoints: {
    640: { slidesPerView: 1 },
    768: { slidesPerView: 1 },
    1024: { slidesPerView: 1 },
  }
});









AOS.init( {  throttleDelay: 200, 
} );


document.addEventListener("DOMContentLoaded", function () {
  const tabs = document.querySelectorAll(".tab-head");
  const panels = document.querySelectorAll(".tab-body");

  tabs.forEach((tab) => {
    tab.addEventListener("click", () => {
      const targetPanelId = tab.getAttribute("aria-controls");

      // Deactivate all tabs and hide all panels
      tabs.forEach((t) => t.setAttribute("aria-selected", "false"));
      panels.forEach((panel) => panel.setAttribute("hidden", "true"));

      // Activate the clicked tab and show the corresponding panel
      tab.setAttribute("aria-selected", "true");
      document.getElementById(targetPanelId).removeAttribute("hidden");
    });
  });
});





document.addEventListener("DOMContentLoaded", function () {
  const tickers = document.querySelectorAll('.ticker-outer');

  tickers.forEach((ticker) => {
    // Prevent double initialization
    if (ticker.dataset.tickerInit === "true") return;
    ticker.dataset.tickerInit = "true";

    const track = ticker.querySelector('.ticker-track');

    function imagesLoaded(container, callback) {
      const images = container.querySelectorAll('img');
      let loaded = 0;
      const total = images.length;
      if (total === 0) return callback();

      images.forEach((img) => {
        if (img.complete) {
          if (++loaded === total) callback();
        } else {
          ['load', 'error'].forEach(event => {
            img.addEventListener(event, () => {
              if (++loaded === total) callback();
            });
          });
        }
      });
    }

    function setupTicker() {
      const slides = Array.from(track.querySelectorAll('.tick-slide, .image-insta-cont'));

      // Remove previous clones
      track.querySelectorAll('.is-clone').forEach(c => c.remove());

      const containerWidth = ticker.offsetWidth;
      const originalsWidth = slides.reduce((sum, s) => sum + s.offsetWidth, 0);

      if (containerWidth === 0 || originalsWidth === 0) return;

      let accumulatedWidth = originalsWidth;
      let cloneCount = 0;
      const maxClones = 20;

      while (accumulatedWidth < containerWidth * 2 && cloneCount < maxClones) {
        slides.forEach(slide => {
          const clone = slide.cloneNode(true);
          clone.classList.add('is-clone');
          track.appendChild(clone);
        });
        accumulatedWidth += originalsWidth;
        cloneCount++;
      }

      let scrollAmount = 0;
      const totalScrollWidth = accumulatedWidth / 2;
      const speed = parseFloat(ticker.dataset.speed) || 1;
      let paused = false; // ⏸️ track pause state

      function animateTicker() {
        if (!paused) {
          scrollAmount -= speed;
          if (Math.abs(scrollAmount) >= totalScrollWidth) scrollAmount = 0;
          track.style.transform = `translate3d(${Math.floor(scrollAmount)}px, 0, 0)`;
        }
        requestAnimationFrame(animateTicker);
      }

      animateTicker();

      // 🎯 Pause only for the Instagram ticker
      if (track.id === "instaticker") {
        ticker.addEventListener("mouseenter", () => (paused = true));
        ticker.addEventListener("mouseleave", () => (paused = false));
      }
    }

    ticker.refreshTicker = () => {
      imagesLoaded(ticker, () => {
        setTimeout(setupTicker, 50);
      });
    };

    imagesLoaded(ticker, () => {
      setTimeout(setupTicker, 50);
    });

    let resizeTimeout;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(setupTicker, 300);
    });
  });
});













const sidecart = document.getElementById('sidecart');
const openBtn = document.getElementById('open-cart-btn');


let previousActiveElement = null; // ✅ Store focus
let releaseFocusTrap = null; // ✅ For cleanup later


function formatPrice(cents) {
// Return just the numeric value as a string, fixed to two decimals
return (cents / 100).toFixed(2);
}


// ✅ Focus trap utility
function trapFocus(container) {
const focusableSelectors = [
'a[href]',
'button:not([disabled])',
'textarea',
'input[type="text"]',
'input[type="number"]',
'input[type="radio"]',
'input[type="checkbox"]',
'select',
'[tabindex]:not([tabindex="-1"])'
];


const focusableEls = container.querySelectorAll(focusableSelectors.join(', '));
const firstEl = focusableEls[0];
const lastEl = focusableEls[focusableEls.length - 1];


function handleKeyDown(e) {
if (e.key === 'Tab') {
if (e.shiftKey) {
if (document.activeElement === firstEl) {
e.preventDefault();
lastEl.focus();
}
} else {
if (document.activeElement === lastEl) {
e.preventDefault();
firstEl.focus();
}
}
}


if (e.key === 'Escape') {
closeSideCart();
}
}


container.addEventListener('keydown', handleKeyDown);
firstEl?.focus();


return () => {
container.removeEventListener('keydown', handleKeyDown);
};
}


// 🎯 Hook up open button
if (openBtn) {
openBtn.addEventListener('click', function (e) {
e.stopPropagation();
openSideCart();
});
}


// 🎯 Click background to close
if (sidecart) {
sidecart.addEventListener('click', function (e) {
if (e.target === sidecart) {
closeSideCart();
}
});
}


document.addEventListener('cart:updated', function () {
openSideCart();
});


function openSideCart() {
sidecart.classList.add('active');
document.body.classList.add('cart-open');
renderCartContents();


// ✅ Trap focus
previousActiveElement = document.activeElement;
releaseFocusTrap = trapFocus(sidecart);
}


function closeSideCart() {
sidecart.classList.remove('active');
document.body.classList.remove('cart-open');


// ✅ Remove trap and restore focus
if (typeof releaseFocusTrap === 'function') releaseFocusTrap();
if (previousActiveElement) previousActiveElement.focus();
}





let cachedCart = null;

// Fetch cart on page load
window.addEventListener('DOMContentLoaded', async () => {
  try {
    const res = await fetch('/cart.js');
    cachedCart = await res.json();
    console.log('Cart cached on page load');
  } catch (err) {
    console.error('Failed to cache cart:', err);
  }
});

async function renderCartContents() {
  const cart = cachedCart || await (await fetch('/cart.js')).json();
  // rest of your render logic...
}





const addToCartButtons = document.querySelectorAll('.cart-btt');

addToCartButtons.forEach(btn => {
  const btnText = btn.querySelector('#carttext'); // get the span inside button
  if (!btnText) return;

  btn.addEventListener('click', e => {
    // Add clicked class for animation
    btn.classList.add('clicked');

    // Change the button text
    const originalText = btnText.textContent;
    btnText.textContent = 'ADDING...';

    // Reset after animation
    setTimeout(() => {
      btn.classList.remove('clicked');
      btnText.textContent = originalText;
    }, 1500); // match animation duration
  });
});













function renderCartContents() {
fetch('/cart.js')
.then(response => response.json())
.then(cart => {
const bag = document.getElementById('Bag');
const cartNumber = document.getElementById('cart-number');
const totalEl = document.querySelector('.cart-total-price');


// Keep the template before clearing content
const template = document.getElementById('template');


if (!template) {
console.error('Template .item-row not found!');
return;
}


// Clear previous cart content
bag.innerHTML = '';


// Handle cart number display regardless of cart state
if (cartNumber) {
const count = cart.item_count;
cartNumber.innerHTML = `<p style="margin: 0px; padding: 0px; font-size: 14px; color:white">${count}</p>`;


if (count === 0) {
cartNumber.style.opacity = '0';
cartNumber.style.display = 'none';
} else {
cartNumber.style.display = 'inline-flex';
cartNumber.style.opacity = '1';
cartNumber.classList.remove('pulse');
void cartNumber.offsetWidth;
cartNumber.classList.add('pulse');
}
}


// Handle empty cart message
if (cart.items.length === 0) {
bag.innerHTML = `
<h4 class="pink">Your Cart is empty!</h4><br><br>
<p><strong><a href="/collections/all" role="link" aria-label="link to shop" class="link">Continue shopping</a></strong></p><br>
`;
}


// Render each cart item
cart.items.forEach(item => {
const clone = template.cloneNode(true);
clone.style.display = 'flex'; // in case template is hidden by default


// Set quantity
const qtyEl = clone.querySelector('.item-qty');
if (qtyEl) qtyEl.textContent = item.quantity;


// Buttons
const increaseBtn = clone.querySelector('.increase-qty');
if (increaseBtn) {
increaseBtn.addEventListener('click', () => {
updateCartItem(item.key, item.quantity + 1);
});
}


const decreaseBtn = clone.querySelector('.decrease-qty');
if (decreaseBtn) {
decreaseBtn.addEventListener('click', () => {
if (item.quantity > 1) {
updateCartItem(item.key, item.quantity - 1);
} else {
removeCartItem(item.key);
}
});
}


const removeBtn = clone.querySelector('.remove-item');
if (removeBtn) {
removeBtn.addEventListener('click', () => {
removeCartItem(item.key);
});
}


// Image
const imgDiv = clone.querySelector('.item-img');
if (imgDiv) {
const smallImage = item.image.replace(/(\.[^.]+)$/, '_compact$1');
imgDiv.innerHTML = `<img src="${smallImage}" alt="${item.title}" style="width: 75px; height: auto;" />`;
}


// Title
const titleEl = clone.querySelector('.item-title');
if (titleEl) titleEl.textContent = item.product_title;


// Discount
const discountEl = clone.querySelector('.discountshow');
if (discountEl) {
const variantText = item.variant_title || '';
const hasLineDiscount = item.line_level_discount_allocations?.length > 0;
const quantity = item.quantity;
const isTierEligible = quantity >= 2;


if (hasLineDiscount && isTierEligible) {
const discount = item.line_level_discount_allocations[0];
const discountAmount = Number(discount.amount);
const discountTitle = discount.discount_application?.title || 'Discount applied';
discountEl.innerHTML = `${variantText ? `${variantText}<br>` : ''}
<span class="discount-title blue" style="font-weight: 400;">${discountTitle} — You saved ${formatPrice(discountAmount)}</span>`;
} else {
discountEl.textContent = variantText;
}
}


// Price
const priceEl = clone.querySelector('.item-price');
if (priceEl) priceEl.textContent = formatPrice(item.line_price);


// Key
clone.dataset.key = item.key;


// Add to bag
bag.appendChild(clone);
});


// Update total
if (totalEl) totalEl.textContent = formatPrice(cart.total_price);
});
}






function updateCartItem(key, quantity) {
fetch('/cart/change.js', {
method: 'POST',
headers: { 'Content-Type': 'application/json' },
body: JSON.stringify({ id: key, quantity })
})
.then(res => res.json())
.then(() => renderCartContents());
}


function removeCartItem(key) {
updateCartItem(key, 0);
}




function formatPrice(cents) {
// Return just the numeric value as a string, fixed to two decimals
return (cents / 100).toFixed(2);
}


function openSideCart() {
document.getElementById('sidecart').classList.add('active');
document.body.classList.add('cart-open'); // Prevent body scroll
renderCartContents();
}


function closeSideCart() {
document.getElementById('sidecart').classList.remove('active');
document.body.classList.remove('cart-open'); // Allow body scroll again
}






























const discountTiers = [
  { minQty: 1, discount: 0 },    // 0% for 1
  { minQty: 2, discount: 0.05 }, // 10% for 2
  { minQty: 3, discount: 0.10 }, // 15% for 3
  { minQty: 4, discount: 0.15 }, // 20% for 4
  { minQty: 5, discount: 0.20 }, // 25% for 5+
];




function getDiscountForQuantity(qty) {
  let applicable = discountTiers[0];
  for (let i = 1; i < discountTiers.length; i++) {
    if (qty >= discountTiers[i].minQty) {
      applicable = discountTiers[i];
    }
  }
  return applicable.discount;
}





function updateDisplayedPrice() {
  const qtyInput = document.querySelector('#qty-custom-input');
  const displayEl = document.querySelector('#displayed-price');
  const basePrice = parseFloat(displayEl.dataset.basePrice);
  const hasDiscounts = displayEl.dataset.hasDiscounts === 'true';

  const qty = parseInt(qtyInput.value, 10) || 1;

  let totalPrice;

  if (hasDiscounts) {
    const discount = getDiscountForQuantity(qty);
    const discountedUnitPrice = basePrice * (1 - discount);
    totalPrice = discountedUnitPrice * qty;
  } else {
    totalPrice = basePrice * qty;
    console.log("backup")
  }

  displayEl.textContent = `${totalPrice.toFixed(2)}`;
}
















document.querySelectorAll('form[action^="/cart/add"]').forEach(form => {
  form.addEventListener('submit', function (e) {
    e.preventDefault(); // Stop default redirect behavior

    const formData = new FormData(form);

    fetch('/cart/add.js', {
      method: 'POST',
      body: formData
    })
      .then(res => res.json())
      .then(() => {
        // Trigger the cart update event
        document.dispatchEvent(new CustomEvent('cart:updated'));
      });
  });


});




document.addEventListener('DOMContentLoaded', function () {
  const noteField = document.getElementById('CartSpecialInstructions');

  if (noteField) {
    noteField.addEventListener('change', function () {
      const formData = new FormData();
      formData.set('note', noteField.value);

      fetch('/cart/update.js', {
        method: 'POST',
        body: formData
      })
      .then(res => res.json())
      .then(cart => {
        console.log('Note saved to cart:', cart.note);
      });
    });
  }
});






document.addEventListener('DOMContentLoaded', function () {
  const buttons = document.querySelectorAll('.collection-link');
  const products = document.querySelectorAll('.product-item');

  // --- Helpers ---
  function filterProducts(filter) {
    products.forEach(product => {
      const productCollections = product.dataset.collection.split(' '); 
      if (filter === 'all' || productCollections.includes(filter)) {
        product.style.display = 'block';
      } else {
        product.style.display = 'none';
      }
    });
  }

  function setActiveButton(activeBtn) {
    buttons.forEach(btn => btn.classList.remove('active'));
    activeBtn.classList.add('active');
  }

  function activateFilter(filter) {
    // find button matching filter
    const targetBtn = Array.from(buttons).find(btn => btn.dataset.filter === filter);
    if (targetBtn) {
      setActiveButton(targetBtn);
      filterProducts(filter);
    }
  }

  // --- On page load, check URL ---
  const urlParams = new URLSearchParams(window.location.search);
  const filterFromURL = urlParams.get('filter') || window.location.hash.replace('#', '');

  if (filterFromURL) {
    activateFilter(filterFromURL);
  } else {
    // default = "all"
    const startButton = document.querySelector('.start-btt');
    if (startButton) {
      activateFilter(startButton.dataset.filter);
    }
  }

  // --- Event listeners ---
  buttons.forEach(button => {
    function handleClick(e) {
      e.preventDefault();
      const filter = button.dataset.filter;
      activateFilter(filter);

      // update URL so it can be linked/bookmarked
      const newUrl = `${window.location.pathname}?filter=${filter}`;
      window.history.replaceState(null, '', newUrl);
    }

    button.addEventListener('click', handleClick);
    button.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        handleClick(e);
      }
    });
  });
});





  document.addEventListener('DOMContentLoaded', function () {
    const qtyInput = document.querySelector('#qty-custom-input');
    const bulkInputWrapper = document.querySelector('#bulk');
    const buttons = document.querySelectorAll('#active-row button');
    const btnPlus = document.querySelectorAll('.qtyplus');
    const btnMinus = document.querySelectorAll('.qtyminus');

    // 1. Handle clicks on qty buttons in #active-row
    buttons.forEach(button => {
      button.addEventListener('click', function () {
        // 1.1 Remove 'active' from all
        buttons.forEach(btn => btn.classList.remove('active'));

        // 1.2 Add 'active' to clicked
        this.classList.add('active');

        // 1.3 Set input value to data-qty
        const qty = parseInt(this.getAttribute('data-qty'), 10);
        if (!isNaN(qty)) {
          qtyInput.value = qty;
          qtyInput.dispatchEvent(new Event('change'));
  updateDisplayedPrice(); 




          
        }

        // 1.4 Show custom input if clicked button is #qty-custom (the "5+" button)
if (this.id === 'show-input' && bulkInputWrapper) {
  bulkInputWrapper.style.display = 'grid';
} else if (bulkInputWrapper) {
  bulkInputWrapper.style.display = 'none';
}

      });
    });





    

    // 2. Handle increment/decrement
btnPlus.forEach(btn => {
  btn.addEventListener('click', function () {
    let val = parseInt(qtyInput.value, 10) || 1;
    qtyInput.value = val + 1;
    qtyInput.dispatchEvent(new Event('change'));
    updateDisplayedPrice();

    // Update announcer
    const announcer = document.getElementById('quantity-announcer');
    if (announcer) {
      announcer.textContent = `Quantity updated to ${qtyInput.value}`;
    }
  });
});


    btnMinus.forEach(btn => {
      btn.addEventListener('click', function () {
        let val = parseInt(qtyInput.value, 10) || 1;
        let min = parseInt(qtyInput.min) || 1;
        if (val > min) {
          qtyInput.value = val - 1;
          qtyInput.dispatchEvent(new Event('change'));
          updateDisplayedPrice();
        }
      });
  const announcer = document.getElementById('quantity-announcer');
    if (announcer) {
      announcer.textContent = `Quantity updated to ${qtyInput.value}`;
    }
      
    });
  });










    const path = document.getElementById("scrollPath");
    const follower = document.getElementById("follower");
    const section = document.getElementById("scroller");

    const pathLength = path.getTotalLength();

    window.addEventListener("scroll", () => {
      const sectionTop = section.offsetTop;
      const sectionHeight = section.offsetHeight;

      // how far we’ve scrolled inside the section
      const scrollY = window.scrollY - sectionTop;
      const progress = Math.min(Math.max(scrollY / sectionHeight, 0), 1);

      // map scroll progress to path length
      const distance = pathLength * progress;
      const point = path.getPointAtLength(distance);

      // move the circle
      follower.setAttribute("cx", point.x);
      follower.setAttribute("cy", point.y);

  
    });






















